import * as React from "react";
import {Mandate} from "@ferry/journey-services";
import {getBrandFromPolicyNumber, WarningBanner, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    haveActiveMandate: boolean
    mandate?: Mandate;
    policyNumber?: string;
}

export class DirectDebitDetailsSection extends React.Component<IProps> {

    public render() {
        const {haveActiveMandate, mandate} = this.props;
        const brandName: string = this.props.policyNumber ?
            getBrandFromPolicyNumber(this.props.policyNumber)! :
            resourcesHelper.THEME_NAME;

        if (haveActiveMandate && mandate) {
            return (
                <div className="d-flex flex-column justify-content-center mt-3 margin-top-0">
                    <div className="mt-1 mb-3 margin-top-0">
                        <b>Name of account holder: </b>
                        {mandate.accountName}
                    </div>
                    <div className="mt-1 mb-3 margin-top-0">
                        <b>Account number: </b>
                        {'*****' + mandate.accountNumber.toString().slice(-3)}
                    </div>
                    <div className="mt-1 mb-3 margin-top-0">
                        <b>Sort code: </b>
                            {`${String(mandate.sortCode).substring(0, 2)} -
                            ${String(mandate.sortCode).substring(2, 4)} -
                            ${String(mandate.sortCode).substring(4, 6)}`}
                    </div>
                </div>
            );
        } else {
            return (
                <WarningBanner wording={<>You no longer have an active Direct Debit with {brandName}.</>}/>
            );
        }
    }

}
